import moment from 'moment';
import _ from 'lodash';
import { dossiers } from '../bff.api';
import responseValidators from '../response.validators';

const _statusChangeBody = (data) => {
  return _.pick(data, ['status', 'remark', 'reason']);
};

const _deadlineChangeBody = (data) => {
  return { deadlineDate: moment(data.deadlineDate, 'DD/MM/YYYY').format('YYYY-MM-DD') };
};

const _assignedUsersChangeBody = (data) => {
  return { assigned: data };
};

const _handleError = (err, onError) => {
  if (onError) {
    onError(err.message);
  }
};

const create = async (dossierType, offering, options = {}) => {
  return dossiers
    .create(dossierType, offering)
    .then((resp) => {
      responseValidators.dossierCreate(resp);
      if (options.onSuccess) {
        options.onSuccess(resp.json);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const statusChange = async (dossierId, data, options = {}) => {
  return dossiers
    .statusChange(dossierId, _statusChangeBody(data))
    .then((resp) => {
      responseValidators.dossierStatusChange(resp);
      if (options.onSuccess) {
        options.onSuccess(resp.json);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const privateModeChange = async (dossierId, isPrivate, options = {}) => {
  return dossiers
    .update(dossierId, { isPrivate })
    .then((resp) => {
      responseValidators.dossierPrivateModeChange(resp);
      if (options.onSuccess) {
        options.onSuccess(resp.json);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const deadlineChange = async (dossierId, deadlineDate, options = {}) => {
  return dossiers
    .update(dossierId, _deadlineChangeBody({ deadlineDate }))
    .then((resp) => {
      responseValidators.dossierDeadlineChange(resp);
      if (options.onSuccess) {
        options.onSuccess(resp.json);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const assignedUsersChange = async (dossierId, data, options = {}) => {
  return dossiers
    .assignedUsersChange(dossierId, _assignedUsersChangeBody(data))
    .then((resp) => {
      responseValidators.dossierAssignedChange(resp);
      if (options.onSuccess) {
        options.onSuccess(resp.json);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const relateDossiers = async (dossierId, data, options = {}) => {
  return dossiers
    .relateDossiers(dossierId, data)
    .then((resp) => {
      responseValidators.dossierRelateDossiers(resp);
      if (options.onSuccess) {
        options.onSuccess(resp.json);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const removeRelations = async (dossierId, ids, options = {}) => {
  return dossiers
    .removeRelations(dossierId, { ids })
    .then((resp) => {
      responseValidators.dossierRemoveRelations(resp);
      if (options.onSuccess) {
        options.onSuccess(resp.json);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const dossiersService = {
  create,
  statusChange,
  privateModeChange,
  deadlineChange,
  assignedUsersChange,
  relateDossiers,
  removeRelations
};

export default dossiersService;
